function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/legend-eau-cours-canalise");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/legend-eau-cours-canalise",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#578FFF",
  points: "28 10 28 20 2 20 2 10"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#F7F7F6",
  points: "28 13 28 17 2 17 2 13"
})));

const SvgIco30EauCoursCanalise = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EauCoursCanalise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-eauCoursCanalise.ad835e3e.svg";
export { ForwardRef as ReactComponent };